import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import { AlertInfo } from "src/@/components/shared/AlertInfo";

const CardFinishChat = ({ 
  user, 
  changeBlock,
  block,
 }) => {

  return (
    <div className="w-full">
        <div className="space-y-4">
          {/* Seleção de Usuário */}
          <div>
            <AlertInfo
                title="Finalizar Chat"
                description="Se houver um chat vinculado, ele será finalizado."
            />
          </div>
        </div>
    </div>
  );
};

export default CardFinishChat;
